export enum SubscriptionEntitlements {
  /** @deprecated - we have deprecated "subscription" entitlement and all new products/bundles should be added to "unlimited" entitlement  */
  'subscription' = 'subscription',
  'unlimited' = 'unlimited',
  'candyjar_unlimited' = 'candyjar_unlimited',
  'weekends' = 'weekends',
  'express_tier1' = 'express_tier1',
  'express_tier2' = 'express_tier2',
  'express_tier3' = 'express_tier3',
  /** These are both for the ads supported subscription test. `with_ads` is from revcat and `unlimited_with_ads` is from stripe. */
  'with_ads' = 'with_ads',
  'unlimited_with_ads' = 'unlimited_with_ads',
  'textonly' = 'textonly',
  'audioonly' = 'audioonly',
  'pointsadd' = 'pointsadd',
}
